import React from 'react';
import { Statistics, Numbers, Message, Loader } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Styles from './statistics.module.css';
import { fetcher } from '@weezevent/weezjs-core';
import { useInterval } from '../../../components/export/exportButton';
import StatisticsMoreLabel, { CreditsStatisticsFooter } from './statisticsComponent';
import i18n from 'i18next';

export function CurrencyContainer({ children }) {
    return <div className={Styles['currency-container']}>{children}</div>;
}

export default function CreditsCard({ organization }) {
    const { t } = useTranslation();
    const locale = i18n.language;
    const updateDelay = 30000;
    const [delay, setDelay] = React.useState(1);
    const [stats, setStats] = React.useState(null);

    const call = React.useCallback(() => {
        setDelay(updateDelay);
        fetcher.get(`/ticket/organizations/${organization.id}/ticket_office/credits`, { cache: false }).then(data => {
            if (data.status === 200) {
                setStats(data.response);
            }
        });
    }, [organization, updateDelay]);

    const moreCreditsUrl = window.weezConfig.moreCreditsURL || 'https://my.weezevent.com/fr-vente-sur-place-achat-de-credits-guichet';

    useInterval(call, delay);

    const StaitsticsCredits = () => {
        if (!stats) {
            return (
                <Statistics className={Styles['statistics-card']} stat="">
                    <Loader inline="centered" />
                </Statistics>
            );
        }

        return (
            <Statistics
                className={Styles['statistics-card']}
                footer={
                    <CreditsStatisticsFooter>
                        <CurrencyContainer>
                            {t('ticket.ticket_offices.statistics_credits.currency')} : {organization.currency}
                        </CurrencyContainer>
                    </CreditsStatisticsFooter>
                }
                graph={null}
                helpLabel={t('ticket.ticket_offices.statistics_credits.help')}
                moreLabel={<StatisticsMoreLabel>{t('ticket.ticket_offices.statistics_credits.buy')}</StatisticsMoreLabel>}
                moreURL={stats?.book_more_url || moreCreditsUrl}
                propsURL={{ target: '_blank', rel: 'noopener' }}
                size="big"
                stat={
                    <span className={Styles['primary_color']}>
                        <Numbers locale={locale} value={stats.remaining} />
                    </span>
                }
                subtitle={t('ticket.ticket_offices.statistics_credits.subtitle')}
            >
                <Statistics.Content>
                    <Statistics.Table
                        data={[
                            {
                                title: <Statistics.CellStyle className={Styles['nowrap-text-cell']}>{t('ticket.ticket_offices.statistics_credits.total')}</Statistics.CellStyle>,
                                value: (
                                    <Statistics.CellStyle bold>
                                        <Numbers locale={locale} value={stats.total} />
                                    </Statistics.CellStyle>
                                )
                            },
                            {
                                title: t('ticket.ticket_offices.statistics_credits.used'),
                                value: (
                                    <Statistics.CellStyle bold>
                                        <Numbers locale={locale} value={stats.used} />
                                    </Statistics.CellStyle>
                                )
                            },
                            {
                                title: t('ticket.ticket_offices.statistics_credits.remaining'),
                                value: (
                                    <Statistics.CellStyle bold>
                                        <Numbers locale={locale} value={stats.remaining} />
                                    </Statistics.CellStyle>
                                )
                            }
                        ]}
                    />
                </Statistics.Content>
            </Statistics>
        );
    };

    return (
        <>
            {stats && stats.remaining <= 0 && (
                <Message
                    title={t('ticket.ticket_offices.statistics_credits.danger_title')}
                    type="danger"
                    links={{
                        label: t('ticket.ticket_offices.statistics_credits.buy'),
                        href: `${window.weezConfig.temporary.menhirUrl}/bo/guichets.php`
                    }}
                >
                    {t('ticket.ticket_offices.statistics_credits.danger_descr')}
                </Message>
            )}
            <StaitsticsCredits />
        </>
    );
}
